import { FullMetadata, StorageReference } from '@angular/fire/storage';

export class SetFileMetaAction {
  public static readonly type = '[Project/Storage/List] SetFileMetaAction';
  constructor(
    public readonly file: StorageReference,
    public readonly meta: FullMetadata,
  ) {}
}
